import { HintCard, styled } from 'canoe';
import React from 'react';

const Container = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  align-self: center;
  height: 480px;
`;
export const ExperimentsPlaceholder = () => (
  <Container data-cy="editor-empty-state-experiments-placeholder">
    <HintCard
      orderedList
      tips={[
        'Create content for Version A by dragging Components from the toolbar (on the left) onto this canvas',
        'Create content for Version B by clicking on the tab at the top of the canvas',
        'Select the audience and distribution in A/B settings (top bar)',
        'Tell us where the versions should be embedded in your product by clicking “Place Versions”',
        'Launch your Experiment!',
      ]}
    />
  </Container>
);
